export module setting{
    export class ApiUrl{
         static current = process.env.NODE_ENV == 'development' ? 'https://localhost:5001/api/' : 'https://api.letsdoitlogin.nu/api/';
        // static current = 'https://letsdoitapi.azureit.se/api/';
        // static current = 'https://api.letsdoitlogin.nu/api/';
    }

    export class HubUrl{
        static current = process.env.NODE_ENV == 'development' ? 'https://localhost:5001/eventhub' : 'https://api.letsdoitlogin.nu/eventhub';
        // static current = 'https://api.letsdoitlogin.nu/eventhub';
    }
}

